import { useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';

export interface TrialBookedCounts {
  today: string;
  byClass: Record<string, number>;
  byOccurrence: Record<string, number>;
}

export const getTrialBookedCounts = async (classIds: string[]) => {
  const response = await baseAPI.get<TrialBookedCounts>(
    '/trialstudents/booked-counts',
    {
      params: { classIds: classIds.join(',') },
    },
  );
  return response.data;
};

export const useGetTrialBookedCounts = (classIds: string[]) => {
  const ids = [...new Set(classIds.filter(Boolean))].sort();
  return useQuery({
    queryKey: ['trial-booked-counts', ids],
    queryFn: () => getTrialBookedCounts(ids),
    enabled: ids.length > 0,
  });
};
